module.exports = __webpack_public_path__ + "assets/img/ty4.13b5d15a.jpg";